const guide = document.querySelector('#scroll-guide');
const delay = 1750;

let timeout = null;

window.addEventListener('scroll', () => {
  if (timeout !== null) {
    clearTimeout(timeout);
    timeout = null;
  }

  guide.classList.add('hide');

  timeout = setTimeout(() => guide.classList.remove('hide'), 1750);
});
